import React from 'react';
import { ClassificationWall } from './pages/ClassificationWall/ClassificationWall';


export const ClassificationApp: React.FC = () => {
  return <ClassificationWall />;
};
